/* eslint-disable no-sequences */
import React from 'react';
import Return from '../../../images/return.png';
import LogoPerguntas from '../../../images/logo-perguntas.png';
import { BaSeButton, BaSeIcon } from '@base/react';
import { AddPerguntasModel } from './addPerguntas.model';
import { mapValueMsg } from './mapValuesPage';
import { formatDefaultValueSelect } from '../../../utils/mask';
import { Autocomplete } from '@material-ui/lab';
import { TextField, Chip } from '@material-ui/core';
import AddAssuntoModal from '../../../components/addAssuntoModal';
import { formatDateToBR } from '../../../utils/time';
import styles from './styles.module.scss';

export const DEFAULT_VALUE_SELECIONE = 'Selecione';

export const AddPerguntas = (props) => {
  const {
    onClose,
    selectedRow,
    allValuesOptions,
    typeScreen,
    setAllValuesOptions,
  } = props;

  const {
    perguntas,
    isLoadingCidades,
    cidades,
    updateValue,
    recoveredByid,
    adicionarNotificacao,
    onChangeUF,
    addAssunto,
    modalAssunto,
  } = AddPerguntasModel({ selectedRow, typeScreen, onClose });

  const backList = () => {
    onClose();
  };

  return (
    <div>
      <div className={styles.container_principal}>
        <div
          className={styles.filtro_container}
          style={{ backgroundColor: '#cc6633' }}
        >
          <div className={styles.modal_flex_direction_row}>
            <img alt="imagem" className="logo-perguntas" src={LogoPerguntas} />
            <h2 className={styles.text_color_branco_titulo}>
              Perguntas frequentes
            </h2>
            <div className={styles.div_acoes_faq}>
              <div className={styles.icons_acoes_modal_filtro}>
                <img
                  onClick={backList}
                  alt="imagem"
                  className={styles.writin}
                  src={Return}
                />
                <p className={styles.text_color_branco}>Voltar</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className={styles.div_tabelas_carrossel_filtro}>
            <div className={styles.separator_perguntas}>
              <h3>{mapValueMsg[typeScreen]}</h3>
            </div>

            <div className={styles.div_acoes_faqs}>
              <div className={styles.container_itens}>
                <p>
                  <p className="text-campos-cadastro">
                    Pergunta{' '}
                    <span className={styles.mandatory_perguntas}>*</span>
                  </p>
                </p>
                <input
                  value={perguntas?.pergunta ?? ''}
                  id="input-nome"
                  onChange={(evento) => {
                    const newValue = evento.target.value;
                    if (newValue.length < 141)
                      updateValue('pergunta', evento.target.value);
                  }}
                  placeholder="Digite aqui o título"
                />
                <div className={styles.sublabel_wrapper}>
                  <p className={styles.sublabel}>
                    {perguntas?.pergunta?.length ?? 0}/140
                  </p>
                </div>
              </div>

              <div
                className={styles.container_itens}
                style={{ display: 'flex' }}
              >
                <div style={{ flex: '1' }}>
                  <p className="text-campos-cadastro">
                    Menu<span className={styles.mandatory_perguntas}>*</span>
                  </p>
                  <select
                    value={perguntas?.menu?.id ?? ''}
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        allValuesOptions.menus,
                        event.target.value,
                        true
                      );
                      updateValue('menu', recovered[0]);
                    }}
                  >
                    <option value={''}>{DEFAULT_VALUE_SELECIONE}</option>

                    {allValuesOptions?.menus.map((menu) => (
                      <option value={menu.id} title={menu.nome}>
                        {formatDefaultValueSelect(menu.nome)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className={styles.div_acoes_faqs}>
              <div className={styles.container_itens}>
                <p className="text-campos-cadastro">
                  Resposta<span className={styles.mandatory_perguntas}>*</span>
                </p>
                <textarea
                  rows="7"
                  value={perguntas?.resposta ?? ''}
                  id="input-descricao"
                  onChange={(evento) => {
                    const newValue = evento.target.value;
                    if (newValue.length < 501)
                      updateValue('resposta', evento.target.value);
                  }}
                  placeholder="Digite aqui a resposta"
                />
                <div className={styles.sublabel_wrapper}>
                  <p className={styles.sublabel}>
                    {perguntas?.resposta?.length ?? 0}/500
                  </p>
                </div>
              </div>
              <div className={styles.container_itens}>
                <div>
                  <div>
                    <p className="text-campos-cadastro">
                      Tipo de usuário
                      {/* <span className={styles.mandatory_perguntas}>*</span> */}
                    </p>
                    <select
                      value={perguntas?.perfilUsuario?.id ?? ''}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          allValuesOptions.perfis,
                          event.target.value,
                          false
                        );
                        updateValue('perfilUsuario', recovered);
                      }}
                    >
                      <option value={''}>Todos</option>
                      {allValuesOptions?.perfis.map((perfil) => (
                        <option value={perfil.id} title={perfil.nome}>
                          {formatDefaultValueSelect(perfil.nome)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <div
                      className="pre-visualizar-container"
                      style={{ marginTop: '1rem' }}
                    >
                      <p className="text-campos-cadastro">
                        Palavra-Chave
                        <span className={styles.mandatory_perguntas}>*</span>
                      </p>
                    </div>
                    <div className={styles.auto_complete_area}>
                      <Autocomplete
                        multiple
                        size="small"
                        id="tags-filled"
                        options={allValuesOptions?.palavrasChave?.map(
                          (pc) => pc.palavra
                        )}
                        onChange={(event, newValue) => {
                          let newVal = perguntas.palavras ?? [];
                          if (newValue.length < newVal.length) {
                            newVal = newValue;
                          } else {
                            newVal.push(
                              allValuesOptions?.palavrasChave[
                                event.target.id.split('-')[3]
                              ]
                            );
                          }

                          updateValue('palavras', newVal);
                        }}
                        value={perguntas?.palavras ?? []}
                        freeSolo
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              variant="outlined"
                              label={option.palavra}
                              {...getTagProps({ index })}
                              size="small"
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Digite aqui"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.div_acoes_faqs}>
              <div className={styles.div_acoes_faqs}></div>
            </div>

            <div className={styles.div_acoes_faqs}>
              <div className={styles.container_itens}>
                <div style={{ display: 'flex' }}>
                  <div style={{ flex: '1' }}>
                    <p className="text-campos-cadastro">
                      Assunto
                      <span className={styles.mandatory_perguntas}>*</span>
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <select
                        value={perguntas?.assunto?.id ?? ''}
                        style={{ marginRight: 10, width: '560px' }}
                        onChange={(event) => {
                          const recovered = recoveredByid(
                            allValuesOptions.assuntos,
                            event.target.value,
                            false
                          );
                          updateValue('assunto', recovered);
                        }}
                      >
                        <option value={''}>{DEFAULT_VALUE_SELECIONE}</option>
                        {allValuesOptions?.assuntos.map((assunto) => {
                          return (
                            <option value={assunto.id} title={assunto.nome}>
                              {formatDefaultValueSelect(assunto.nome)}
                            </option>
                          );
                        })}
                      </select>
                      <BaSeIcon
                        onClick={() => addAssunto()}
                        name="plus-circle"
                        description="Adicionar novidade"
                        color="#cc6633"
                        size={30}
                      />
                    </div>
                  </div>
                  <div className="flex-1"></div>
                </div>
              </div>
            </div>

            <div className={styles.div_acoes_faqs}>
              <div className={styles.container_itens}></div>
            </div>

            <div className={styles.separator_perguntas}>
              <h3>Abrangência da Pergunta</h3>
            </div>

            <div className={styles.div_acoes_faqs}>
              <div className={styles.container_itens}>
                <div className={styles.local_wrapper} style={{ height: 100 }}>
                  <div>
                    <p className="text-campos-cadastro">UF</p>
                    <select
                      style={{ width: '70px', marginRight: '1rem' }}
                      value={perguntas?.uf?.id ?? ''}
                      className="btn-select-funcionalidades"
                      onChange={(event) =>
                        onChangeUF(allValuesOptions.ufs, event.target.value)
                      }
                    >
                      <option value={''}>Todas</option>
                      {allValuesOptions?.ufs.map((uf) => (
                        <option value={uf.id} title={uf.nome}>
                          {uf.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ flex: 1, maxWidth: 500 }}>
                    <p className="text-campos-cadastro">Cidade</p>
                    <select
                      disabled={isLoadingCidades}
                      value={perguntas?.cidade?.id ?? ''}
                      className="btn-select-funcionalidades"
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          cidades,
                          event.target.value,
                          false
                        );
                        updateValue('cidade', recovered);
                      }}
                    >
                      {isLoadingCidades ? (
                        <option value={''}>Carregando cidades</option>
                      ) : (
                        <>
                          <option value={''}>Todas</option>
                          {cidades.map((cidade) => (
                            <option value={cidade.id} title={cidade.nome}>
                              {cidade.nome}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <div
                className={styles.flex_button}
                style={{ alignSelf: 'flex-end' }}
              >
                <BaSeButton
                  color="#cc6633"
                  value={
                    typeScreen !== 3 ? 'Incluir Pergunta' : 'Editar Pergunta'
                  }
                  onClick={adicionarNotificacao}
                />
              </div>
            </div>
          </div>
          <AddAssuntoModal
            open={modalAssunto}
            onAction={() => addAssunto()}
            setAllValuesOptions={(options) => {
              setAllValuesOptions(options);
            }}
          />
        </div>
        {/* Resgistro data INCLUSÃO-ALTERAÇÃO */}
        <div className={styles.updatedAt_perguntas_container}>
          {perguntas.atualizadoPor && typeScreen === 3 && (
            <h5>
              Atualizado em {formatDateToBR(perguntas.ultimaAtualizacao)} por{' '}
              {perguntas?.atualizadoPor?.nome}
            </h5>
          )}
          {perguntas.criadoPor && typeScreen === 3 && (
            <h5>
              Criado em {formatDateToBR(perguntas.dataCriacao)} por{' '}
              {perguntas?.criadoPor?.nome}
            </h5>
          )}
        </div>
      </div>
    </div>
  );
};
